// Доступ к страницам магазина (корзина). В отличие от user-only,
// проверяет не только факт входа, но и роль — либо публичный флаг.
export default defineNuxtRouteMiddleware(() => {
  const shopAccess = useShopAccess();
  if (!shopAccess.value) return navigateTo({ name: "login" });
});
